import angular from 'angular';
import homeComponent from './home.component';
import HomeService from './home.service';
import homeConfig from './home.config';
import BrandsModule from './brands/brands';
import MenuModule from './menu/menu';
import SlidersModule from './sliders/sliders';

import CarouselCategoryModule from './carousel-category/carousel-category';
import FeaturedSliderModule from './featured-slider/featured-slider';

let homeModule = angular.module('home', [
        BrandsModule.name,
        MenuModule.name,
        SlidersModule.name,
        CarouselCategoryModule.name,
        FeaturedSliderModule.name])
    .component('home', homeComponent)
    .service('HomeService', HomeService)
    .config(homeConfig);

export default homeModule;



// WEBPACK FOOTER //
// ./www/components/home/home.js